import { observer } from 'mobx-react';
import { Outlet } from 'react-router-dom';

import PrivateMenu from './private-menu';
import { appStore } from '../stores/app-store';
import { Spinner } from '../components/spinner';
import { ToastProvider } from '../contexts/toast-context';
import { AuthRequired } from '../components/authentication/auth-required';

/**
 * The layout for private pages.
 * @returns
 */
const Private = observer(() => {
  return (
    <AuthRequired>
      <ToastProvider>
        <div className={'layout layout--private'}>
          {appStore.isLoading() && <Spinner />}
          <PrivateMenu />
          <div className={'app-main'}>
            <Outlet />
          </div>
        </div>
      </ToastProvider>
    </AuthRequired>
  );
});

export default Private;
